/* eslint-disable logical-assignment-operators */
/* eslint-disable import/no-extraneous-dependencies */
/* eslint-disable no-unused-vars */
/* eslint-disable react/no-string-refs */

import {
  Button,
  FormControl,
  InputLabel,
  List,
  ListItem,
  ListItemIcon,
  ListItemText,
  MenuItem,
  Select,
  Table, TableBody, TableCell, TableHead, TableRow,
} from '@mui/material';
import moment from 'moment';

import { InfoOutlined } from '@mui/icons-material';
import React, { useEffect, useRef, useState } from 'react';
import { renderToStaticMarkup } from 'react-dom/server';
import { useSelector } from 'react-redux';
import { useNavigate } from 'react-router-dom';
import ClimbingBoxLoader from 'react-spinners/ClimbingBoxLoader';
import { v4 } from 'uuid';
import { useTranslation } from '../common/components/LocalizationProvider';
import PageLayout from '../common/components/PageLayout';
import TableShimmer from '../common/components/TableShimmer';
import '../common/tickets.css';
import { useAheadTimeThreshold } from '../common/util/permissions';
import { formatDate, isMobile } from '../common/util/utils';
import TableExitsReport from '../main/components/TableExitsReport';
import TimeUpdateBtn from '../main/components/TimeUpdateBtn';
import { useCatch } from '../reactHelper';
import scheduleReport from './common/scheduleReport';
import useReportStyles from './common/useReportStyles';
import ReceiptPrintView from './components/ReceiptPrintView';
import ReportFilter from './components/ReportFilter';
import ReportsMenu from './components/ReportsMenu';

export function formatearFechaES(fecha) {
  const date = new Date(fecha);

  const fechaParte = new Intl.DateTimeFormat("es-ES", {
    weekday: "long",
    day: "numeric",
    month: "long",
    year: "numeric",
  }).format(date);

  const horaParte = new Intl.DateTimeFormat("es-ES", {
    hour: "2-digit",
    minute: "2-digit",
    second: "2-digit",
    hour12: false,
  }).format(date);

  return `${fechaParte} a las ${horaParte}`;
}

export function formatearHotaES(fecha) {
  const date = new Date(fecha);

  const horaParte = new Intl.DateTimeFormat("es-ES", {
    hour: "2-digit",
    minute: "2-digit",
    second: "2-digit",
    hour12: false,
  }).format(date);

  return `${horaParte}`;
}


const TicketReportPage = () => {
  const navigate = useNavigate();
  const classes = useReportStyles();
  const t = useTranslation();
  const tableBodyRef = useRef(null);
  const rowRefs = useRef({});

  const devices = useSelector((state) => state.devices.items);
  const subusers = useSelector((state) => state.session.subusers);
  const aheadTime = useAheadTimeThreshold();

  const [loading, setLoading] = useState(false);
  const [validity, setValidity] = useState(0);

  const calcValidity = (tickets) => ((tickets.reduce((acc, obj) => acc + (obj.enterTime ? 1 : 0), 0) * 100) / tickets.length) >= validity;


  // vars for remake
  const [uiSalidas, setUiSalidas] = useState({});
  const [routeName, setRouteName] = useState('');
  const [committing, setCommitting] = useState(false);
  const [committed, setCommitted] = useState(false);
  const [extraCharges, setExtraCharges] = useState([]);

  const isPunishable = (ticket) =>
    (ticket.raw?.difference > 0 && ticket.raw?.punishment > 0) || (ticket.raw.progressPunishment > 0) || (ticket.raw.globalCostPunishment);

  const needsRecalculation = (ticket) =>
    ticket.raw?.enterTime === null || ticket.raw?.enterTime === undefined;

  const handleDownload = (url) => {
    // Disable the button and set loading state to true
    setLoading(true);

    // URL of the file to download
    const downloadUrl = url;

    // Create a new XMLHttpRequest
    const xhr = new XMLHttpRequest();

    // Handle completion of the download
    xhr.addEventListener('load', () => {
      // Once the download is complete, enable the button and reset loading state
      setLoading(false);

      // Handle the downloaded data
      const blob = new Blob([xhr.response], { type: xhr.getResponseHeader('Content-Type') });

      // Create a blob URL for the downloaded file
      const url = window.URL.createObjectURL(blob);

      // Create an anchor element for the download link
      const a = document.createElement('a');
      a.style.display = 'none';
      a.href = url;
      a.download = 'report.xlsx'; // Specify the desired file name
      document.body.appendChild(a);

      // Trigger a click event to start the download
      a.click();

      // Clean up by revoking the blob URL
      window.URL.revokeObjectURL(url);
    });

    // Handle any errors during the download
    xhr.addEventListener('error', () => {
      // Handle download error

      // Enable the button and reset loading state
      setLoading(false);
    });

    // Open the request and start the download
    xhr.open('GET', downloadUrl);
    xhr.responseType = 'blob'; // Set the response type to 'blob'
    xhr.send();
  };

  const handleSubmit = useCatch(async ({ deviceIds, groupIds, from, to, type, unify }) => {
    setRouteName('');
    setUiSalidas({});
    window.filters = { deviceIds, groupIds, from, to, type, unify };
    const query = new URLSearchParams({ from, to });
    deviceIds.forEach((deviceId) => query.append('deviceId', deviceId));
    groupIds.forEach((groupId) => query.append('groupId', groupId));
    query.append('unify', unify);
    if (type === 'export') {
      handleDownload(`/api/reports/tickets/xlsx?${query.toString()}`);
      // window.location.assign(`/api/reports/tickets/xlsx?${query.toString()}`);
    } else if (type === 'mail') {
      const response = await fetch(`/api/reports/tickets/mail?${query.toString()}`);
      if (!response.ok) {
        throw Error(await response.text());
      }
    } else {
      await fetchTickets(query)
    }
  });

  const fetchTickets = async (query) => {
    setLoading(true);
    try {
      const response = await fetch(`/api/reports/tickets?${query.toString()}`, {
        headers: { Accept: 'application/json' },
      });
      if (response.ok) {
        const items = await response.json();

        const uiData = buildUiSalidas(items);
        setUiSalidas(uiData);
      } else {
        throw Error(await response.text());
      }
    } finally {
      setLoading(false);
    }
  }

  const handleSchedule = useCatch(async (deviceIds, groupIds, report) => {
    report.type = 'route';
    const error = await scheduleReport(deviceIds, groupIds, report);
    if (error) {
      throw Error(error);
    } else {
      navigate('/reports/scheduled');
    }
  });

  useEffect(() => {
    // Attach the function to the global window object
    window.rowRefs = rowRefs;

    // Clean up the function when the component unmounts
    return () => {
      delete window.rowRefs;
    };
  }, []);

  useEffect(() => {
    let ticking = false;

    const tableBodyNode = tableBodyRef.current?.parentNode?.parentNode;
    if (tableBodyNode) {
      const handleScroll = (_) => {
        if (!ticking) {
          window.requestAnimationFrame(() => {
            ticking = false;
          });

          ticking = true;
        }
      };

      tableBodyNode.addEventListener('scroll', handleScroll, { passive: true });

      return () => {
        tableBodyNode.removeEventListener('scroll', handleScroll, { passive: true });
      };
    }
    return () => null;
  }, [tableBodyRef]);

  const calcDiffColor = (ticket) => {
    let border = '#163b61';
    let backgroundColor = '#9dc5ff  ';

    if (ticket.enterTime === undefined || ticket.enterTime === null) {
      border = '#163b61';
      backgroundColor = '#9dc5ff';
    } else if (parseInt((moment.duration(moment(ticket.enterTime).tz('America/Mexico_City').diff(moment(ticket.expectedTime).tz('America/Mexico_City')))).asMinutes(), 10) <= -aheadTime) {
      border = '#cc9c00';
      backgroundColor = '#ffe798';
    } else if (parseInt((moment.duration(moment(ticket.enterTime).tz('America/Mexico_City').diff(moment(ticket.expectedTime).tz('America/Mexico_City')))).asMinutes(), 10) <= 0 && parseInt((moment.duration(moment(ticket.enterTime).tz('America/Mexico_City').diff(moment(ticket.expectedTime).tz('America/Mexico_City')))).asMinutes(), 10) > -aheadTime) {
      border = '#065f46';
      backgroundColor = '#d1fae5';
    } else if (parseInt((moment.duration(moment(ticket.enterTime).tz('America/Mexico_City').diff(moment(ticket.expectedTime).tz('America/Mexico_City')))).asMinutes(), 10) > 0) {
      border = '#ff185d';
      backgroundColor = '#fde1f0';
    } else {
      border = '#163b61';
      backgroundColor = '#9dc5ff';
    }

    return { backgroundColor, border, borderStyle: 'solid', borderWidth: '3px', marginBottom: '3px', borderRadius: '8px' };
  };

  const reload = async ({ id }) => {
    let { deviceIds, groupIds, from, to, type, unify } = window.filters;
    const query = new URLSearchParams({ from, to });
    deviceIds.forEach((deviceId) => query.append('deviceId', deviceId));
    groupIds.forEach((groupId) => query.append('groupId', groupId));
    query.append('unify', unify);

    Notiflix.Loading.dots('Actualizando', { backgroundColor: 'rgba(0,0,0,1)' });
    await fetchTickets(query);
    // rowRefs.current[id]?.scrollIntoView({ behaviour: 'smooth', block: 'center' });
    setTimeout(() => {
      try {
        rowRefs.current[id].start.scrollIntoViewIfNeeded();
      } catch (error) {

      }
      Notiflix.Loading.remove();
    }, 500);
  }

  const buildUiSalidas = (apiItems) => {
    return apiItems.reduce((acc, obj) => {
      const salidaId = obj.salida;

      if (!acc[salidaId]) {
        acc[salidaId] = {
          id: salidaId,
          processingState: obj.s.receiptId > 0 ? 'locked' : 'included',
          omitReason: obj.s.excuse || '',
          meta: obj.s,
          receipt: obj.r,
          tickets: [],
          locked: obj.s.receiptId > 0,
          computedNotes: []
        };

      }

      acc[salidaId].tickets.push({
        id: obj.id,
        raw: obj,                 // immutable backend ticket
        forgiven: (obj.excuse && obj.excuse !== '') ? true : false,          // future use
        excuse: obj.excuse || '',               // future use
      });

      if (obj.progressPunishment && obj.progressPunishment > 0) {
        acc[salidaId].computedNotes.push(`Se aplica cobro por adelanto en el ticket de el dia ${formatearFechaES(obj.expectedTime)} ${obj.punishment} -> ${obj.progressPunishment}`);
      }

      if (obj.globalCostPunishment && obj.globalCostPunishment > 0) {
        acc[salidaId].computedNotes.push(`Se aplica cobro cuota global en el ticket de el dia ${formatearFechaES(obj.expectedTime)} ${obj.punishment} -> ${obj.globalCostPunishment}`);
      }

      return acc;
    }, {});
  };

  const updateSalidaOmitReason = (salidaId, reason) => {
    setUiSalidas(prev => ({
      ...prev,
      [salidaId]: {
        ...prev[salidaId],
        omitReason: reason,
      },
    }));
  };

  const setSalidaState = (salidaId, state) => {
    setUiSalidas(prev => ({
      ...prev,
      [salidaId]: {
        ...prev[salidaId],
        processingState: state,
        omitReason: state === 'omitted' ? prev[salidaId].omitReason : '',
      },
    }));
  };

  const updateTicketExcuse = (salidaId, ticketId, excuse) => {
    setUiSalidas(prev => ({
      ...prev,
      [salidaId]: {
        ...prev[salidaId],
        tickets: prev[salidaId].tickets.map(t =>
          t.id === ticketId
            ? {
              ...t,
              excuse,
              forgiven: (excuse || '').trim().length > 0,
            }
            : t
        ),
      },
    }));
  };

  const recalculateTicket = async (salidaId, ticketId) => {
    // Mark ticket as recalculating
    setUiSalidas(prev => ({
      ...prev,
      [salidaId]: {
        ...prev[salidaId],
        tickets: prev[salidaId].tickets.map(t =>
          t.id === ticketId
            ? { ...t, recalculating: true }
            : t
        ),
      },
    }));

    try {
      const response = await fetch('/api/tickets/recalculate', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ id: ticketId }),
      });

      if (!response.ok) {
        throw new Error(await response.text());
      }

      const updatedTicket = await response.json();

      // Merge updated raw ticket, preserve UI state
      setUiSalidas(prev => ({
        ...prev,
        [salidaId]: {
          ...prev[salidaId],
          tickets: prev[salidaId].tickets.map(t =>
            t.id === ticketId
              ? {
                ...t,
                raw: { ...t.raw, difference: updatedTicket.difference, enterTime: updatedTicket.enterTime, punishment: updatedTicket.punishment },
                recalculating: false,
              }
              : t
          ),
        },
      }));
    } catch (error) {
      console.error('Recalculation failed:', error);

      // Clear recalculating flag on error
      setUiSalidas(prev => ({
        ...prev,
        [salidaId]: {
          ...prev[salidaId],
          tickets: prev[salidaId].tickets.map(t =>
            t.id === ticketId
              ? { ...t, recalculating: false }
              : t
          ),
        },
      }));
    }
  };

  const getTicketPunishment = (t) => {
    if (!isPunishable(t)) return 0;
    if (t.forgiven) return 0;
    if (t.raw.progressPunishment > 0) return Number(t.raw.progressPunishment);
    if (t.raw.globalCostPunishment) return Number(t.raw.globalCostPunishment);
    return Number(t.raw.punishment) || 0;
  };

  const addExtraCharge = () => {
    setExtraCharges(prev => [
      ...prev,
      { id: v4(), description: '', amount: 0 }
    ]);
  };

  const updateExtraCharge = (id, field, value) => {
    setExtraCharges(prev =>
      prev.map(c =>
        c.id === id
          ? { ...c, [field]: field === 'amount' ? Number(value) : value }
          : c
      )
    );
  };

  const removeExtraCharge = (id) => {
    setExtraCharges(prev => prev.filter(c => c.id !== id));
  };

  const sanitizedExtraCharges = extraCharges.filter(
    c => c.description.trim() !== '' && Number(c.amount) > 0
  );


  const getExtraChargesTotal = () => {
    return sanitizedExtraCharges.reduce(
      (sum, c) => sum + (Number(c.amount) || 0),
      0
    );
  };

  const getSalidaTotal = (salida) => {
    if (salida.processingState !== 'included') return 0;
    if (salida.meta.receiptId > 0) return 0;

    return salida.tickets.reduce(
      (sum, t) => sum + getTicketPunishment(t),
      0
    );
  };


  const getGlobalTotal = (uiSalidas) =>
    Object.values(uiSalidas).reduce(
      (sum, salida) => sum + getSalidaTotal(salida),
      0
    ) + getExtraChargesTotal();

  const getOmittedSalidas = (uiSalidas) =>
    Object.values(uiSalidas)
      .filter(s => s.processingState === 'omitted')
      .map(s => ({
        id: s.id,
        reason: s.omitReason,
        date: s.meta.date
      }));

  const getChargeableSalidas = (uiSalidas) =>
    Object.values(uiSalidas)
      .filter(s => s.processingState === 'included')
      .map(s => ({
        id: s.id,
        reason: s.omitReason,
        date: s.meta.date
      }));

  const getExcusedTickets = (uiSalidas, options = {}) => {
    const {
      mode = 'current', // 'current' | 'receipt'
      receiptId = null,
    } = options;

    return Object.values(uiSalidas)
      .filter(salida => {
        if (mode === 'current') {
          // Only salidas being processed right now
          return salida.processingState === 'included' ||
            salida.processingState === 'omitted';
        }

        if (mode === 'receipt') {
          // Only salidas belonging to that receipt
          return salida.meta.receiptId === receiptId;
        }

        return false;
      })
      .flatMap(salida =>
        salida.tickets
          .filter(t => t.forgiven && t.excuse !== '')
          .map(t => ({
            salidaId: salida.id,
            ticketId: t.id,
            excuse: t.excuse,
            punishment: t.raw.punishment,
          }))
      );
  };

  const buildReceiptData = () => {
    return {
      routeName,
      // date: new Date().toLocaleString(),
      date: new Date().toISOString(),
      salidas: Object.values(uiSalidas)
        // .filter(s => s.included)
        .filter(s => s.processingState === 'included')
        .map(s => ({
          id: s.id,
          total: getSalidaTotal(s),
          date: s.meta.date,
          tickets: s.tickets.map(t => ({
            id: t.id,
            device: devices[t.raw.device]?.name,
            geofence: t.raw.geofence,
            expectedTime: t.raw.expectedTime,
            enterTime: t.raw.enterTime,
            difference: t.raw.difference,
            punishment: t.raw.punishment,
            forgiven: t.forgiven,
            excuse: t.excuse,
          })),
        })),
      omittedSalidas: getOmittedSalidas(uiSalidas),
      excusedTickets: getExcusedTickets(uiSalidas, {
        mode: 'current',
      }),
      extraCharges: sanitizedExtraCharges,
      extraChargesTotal: getExtraChargesTotal(),
      // extraChargesSerialized: JSON.stringify(sanitizedExtraCharges),
      globalTotal: getGlobalTotal(uiSalidas),
    };
  };

  const printReceipt = (receiptData, simplify = true) => {
    const win = window.open('', '_blank');


    const data = !simplify ? receiptData : {
      ...receiptData, salidas: receiptData.salidas.filter(salida =>
        salida.total > 0 ||
        salida.tickets.some(ticket => ticket.excuse && ticket.excuse.trim() !== '')
      )
    };
    console.log({ data });

    win.document.write(
      renderToStaticMarkup(
        <ReceiptPrintView data={data} />
      )
    );
    win.document.close();
    win.focus();
    win.print();
    win.close();
  };

  const validateBeforeCommit = () => {
    // if (!routeName.trim()) {
    //   throw new Error('El nombre de la ruta es obligatorio');
    // }

    const omitted = getOmittedSalidas(uiSalidas);
    const missingReasons = omitted.filter(o => !o.reason?.trim());

    if (missingReasons.length > 0) {
      throw new Error('Todas las salidas omitidas deben tener un motivo');
    }

    if (getGlobalTotal(uiSalidas) < 0) {
      throw new Error('El total no es válido');
    }
  };

  const refetchWithCurrentFilters = async () => {
    const { deviceIds, groupIds, from, to, unify } = window.filters || {};
    if (!deviceIds || !groupIds) return;

    const query = new URLSearchParams({ from, to });
    deviceIds.forEach((deviceId) => query.append('deviceId', deviceId));
    groupIds.forEach((groupId) => query.append('groupId', groupId));
    query.append('unify', unify);

    await fetchTickets(query);
  };


  const commitAndPrint = async () => {
    try {
      validateBeforeCommit();

      setCommitting(true);

      const receiptData = buildReceiptData();

      const response = await fetch('/api/tickets/commit', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify(receiptData),
      });

      if (!response.ok) {
        throw new Error(await response.text());
      }

      const commitResult = await response.json();

      setCommitted(true);

      // Print only after commit succeeds
      printReceipt({
        ...receiptData,
        commitId: commitResult.commitId,
        committedAt: commitResult.storedAt,
      });
      await refetchWithCurrentFilters();
    } catch (err) {
      console.log(err);

      alert(err.message);
    } finally {
      setCommitting(false);
    }
  };


  const getReceiptsMap = (uiSalidas) =>
    Object.values(uiSalidas).reduce((acc, s) => {
      const rid = s.meta.receiptId;
      if (!rid || rid <= 0) return acc;

      if (!acc[rid]) acc[rid] = [];
      acc[rid].push(s);
      return acc;
    }, {});

  const buildReceiptDataFromReceiptId = (receiptId) => {
    const salidas = Object.values(uiSalidas)
      .filter(s => s.meta.receiptId === receiptId);

    const omittedSalidas = salidas
      .filter(s => s.omitReason !== '')
      .map(s => ({
        id: s.id,
        reason: s.omitReason,
        date: s.meta.date,
        ...s
      }));

    const excusedTickets = getExcusedTickets(uiSalidas, {
      mode: 'receipt',
      receiptId,
    });

    const chargeableSalidas = salidas.filter(s => s.locked);

    const getSalidaTotal = (salida) => {
      return salida.tickets.reduce(
        (sum, t) => sum + getTicketPunishment(t),
        0
      );
    };

    const globalTotal = chargeableSalidas.reduce(
      (sum, s) => sum + getSalidaTotal(s),
      0
    ) - omittedSalidas.reduce(
      (sum, s) => sum + getSalidaTotal(s),
      0
    );

    const otherCharges = JSON.parse(salidas[0].receipt.otherCharges || '[]');

    const getExtraChargesTotal = () => {
      return otherCharges.reduce(
        (sum, c) => sum + (Number(c.amount) || 0),
        0
      );
    };

    return {
      routeName: routeName || `Recibo #${receiptId}`,
      date: new Date(salidas.at(0).receipt.storedAt).toISOString(),
      commitId: receiptId,
      salidas: chargeableSalidas.map(s => ({
        id: s.id,
        total: getSalidaTotal(s),
        date: s.meta.date,
        tickets: s.tickets.map(t => ({
          id: t.id,
          device: devices[t.raw.device]?.name,
          geofence: t.raw.geofence,
          expectedTime: t.raw.expectedTime,
          enterTime: t.raw.enterTime,
          difference: t.raw.difference,
          punishment: t.raw.punishment,
          forgiven: t.forgiven,
          excuse: t.excuse,
          progressPunishment: t.raw.progressPunishment,
          globalCostPunishment: t.raw.globalCostPunishment
        })),
        computedNotes: s.computedNotes
      })),
      omittedSalidas,
      excusedTickets,
      extraCharges: otherCharges,
      extraChargesTotal: getExtraChargesTotal(),
      globalTotal,
    };
  };

  const omitted = getOmittedSalidas(uiSalidas);
  const excused = getExcusedTickets(uiSalidas, {
    mode: 'current',
  });
  const chargeable = getChargeableSalidas(uiSalidas);
  const receiptsMap = getReceiptsMap(uiSalidas);



  useEffect(() => {

  }, [routeName, uiSalidas])
  return (
    <PageLayout menu={< ReportsMenu />} breadcrumbs={['reportTitle', 'reportRoute']} >
      <div className={classes.container}>
        <div className={classes.containerMain}>
          <div className={classes.header}>
            <ReportFilter
              handleSubmit={handleSubmit}
              handleSchedule={handleSchedule}
              customDayOnly={true}
            >
              <FormControl style={{ width: '20vw' }}>
                <InputLabel>%</InputLabel>
                <Select
                  label="%"
                  value={validity}
                  onChange={(event) => setValidity(event.target.value)}
                >
                  <MenuItem key={`k-validity-${0}`} value={0}>-- Sin filtrar --</MenuItem>
                  <MenuItem key={`k-validity-${10}`} value={10}>10</MenuItem>
                  <MenuItem key={`k-validity-${20}`} value={20}>20</MenuItem>
                  <MenuItem key={`k-validity-${30}`} value={30}>30</MenuItem>
                  <MenuItem key={`k-validity-${40}`} value={40}>40</MenuItem>
                  <MenuItem key={`k-validity-${50}`} value={50}>50</MenuItem>
                  <MenuItem key={`k-validity-${60}`} value={60}>60</MenuItem>
                  <MenuItem key={`k-validity-${70}`} value={70}>70</MenuItem>
                  <MenuItem key={`k-validity-${80}`} value={80}>80</MenuItem>
                  <MenuItem key={`k-validity-${90}`} value={90}>90</MenuItem>
                  <MenuItem key={`k-validity-${100}`} value={100}>100</MenuItem>
                </Select>
              </FormControl>
            </ReportFilter>
          </div>

          <br />

          <input
            type="text"
            placeholder="Nombre de la ruta"
            value={routeName}
            onChange={(e) => setRouteName(e.target.value)}
            style={{
              width: '800px',          // or '50%' or whatever you prefer
              maxWidth: '100%',
              padding: '8px',
              margin: '0 auto 16px auto',  // ← centers horizontally
              display: 'block',            // ← required for margin auto to work
              borderRadius: '6px',
              border: '1px solid #ccc',
            }}
          />


          {(isMobile() === true) ? (
            !loading ? Object.keys(uiSalidas).filter((salida) => calcValidity(uiSalidas[salida].tickets.map(t => t.raw))).map((salida) => (
              <>
                <div style={{ marginBottom: '2vh' }} />
                <TableExitsReport
                  data={{
                    ...uiSalidas[salida],
                    ticket: uiSalidas[salida].tickets.map(t => t.raw),
                    s: uiSalidas[salida].meta,
                  }}
                />

                <div style={{ marginBottom: '5vh' }} />
              </>
            )) : (
              <div style={{
                width: '100vw',
                height: '100vh',
                position: 'relative',
              }}
              >
                <ClimbingBoxLoader
                  style={{
                    width: '50%',
                    height: '50%',
                    position: 'absolute',
                    top: '0%',
                    left: '30%',
                    margin: '-25px 0 0 -25px',
                  }}
                  color="#000000"
                  loading={loading}
                  cssOverride={{}}
                  size={10}
                  aria-label="Cargando información"
                  data-testid="loader"
                />
              </div>
            )
          ) : (
            <Table>
              <TableHead>
                <TableRow key='headers'>
                  <TableCell className={classes.columnAction} />
                  <TableCell>{t('sharedDevice')}</TableCell>
                  <TableCell>{t('sharedGeofence')}</TableCell>
                  <TableCell>{t('groupParent')}</TableCell>
                  <TableCell>Hora programada</TableCell>
                  <TableCell>Hora de ingreso</TableCell>
                  <TableCell>Diferencia</TableCell>
                  <TableCell>Castigo</TableCell>
                  <TableCell>Excusa</TableCell>
                  <TableCell>Total salida</TableCell>

                </TableRow>
              </TableHead>

              <TableBody
                ref={tableBodyRef}
              >
                {!loading ? Object.keys(uiSalidas).filter((salida) => calcValidity(uiSalidas[salida].tickets.map(t => t.raw))).map((salida) => {
                  const isIncluded = uiSalidas[salida].included;
                  const hasReceipt = uiSalidas[salida].meta.receiptId > 0;
                  const receipt = uiSalidas[salida].meta.receiptId;
                  const isLocked = uiSalidas[salida].locked;

                  return (
                    <React.Fragment key={`fragment-salida-${salida}`}>
                      <TableRow key={`salida-${salida}`} ref={el => rowRefs.current[salida] = { start: el }}>
                        <TableCell colSpan={2}>
                          <label style={{ display: 'flex', alignItems: 'center', gap: '8px' }}>
                            {!isLocked && (
                              <div style={{ display: 'flex', gap: '12px' }}>
                                <label>
                                  <input
                                    type="radio"
                                    checked={uiSalidas[salida].processingState === 'included'}
                                    onChange={() => setSalidaState(salida, 'included')}
                                  />
                                  Incluir
                                </label>

                                <label>
                                  <input
                                    type="radio"
                                    checked={uiSalidas[salida].processingState === 'omitted'}
                                    onChange={() => setSalidaState(salida, 'omitted')}
                                  />
                                  Omitir
                                </label>

                                <label>
                                  <input
                                    type="radio"
                                    checked={uiSalidas[salida].processingState === 'ignored'}
                                    onChange={() => setSalidaState(salida, 'ignored')}
                                  />
                                  Ignorar
                                </label>
                              </div>
                            )}

                            {`Salida: ${salida}`}
                            {hasReceipt && (
                              <span style={{ color: '#a00', marginLeft: '8px' }}>
                                (ya cobrada – recibo #{receipt})
                              </span>
                            )}

                          </label>

                        </TableCell>

                        <TableCell colSpan={2}>
                          {`Salida generada el ${formatearFechaES(uiSalidas[salida].meta.date)}`}
                        </TableCell>
                        {(uiSalidas[salida].meta.modifiedBy > 0) ? (
                          <TableCell colSpan={2}>
                            {`La hora fue modificada por el sub-usuario: ${uiSalidas[salida].meta.modifiedBy} - ${subusers.find((su) => su.id === uiSalidas[salida].meta.modifiedBy)?.name} el dia: ${new Date(uiSalidas[salida].meta.modifiedWhen).toLocaleString()}`}
                          </TableCell>
                        ) : <TableCell colSpan={2} />}

                        <TableCell colSpan={3} className="no-print">
                          {(uiSalidas[salida].meta.modifiedBy === 0 || uiSalidas[salida].meta.modifiedBy === null) && (
                            <TimeUpdateBtn
                              id={salida}
                              subusers={subusers}
                              callback={reload}
                            />
                          )}
                        </TableCell>

                        <TableCell>
                          <strong>${getSalidaTotal(uiSalidas[salida]).toFixed(2)}</strong>
                        </TableCell>

                      </TableRow>
                      {(
                        uiSalidas[salida].processingState === 'omitted' ||
                        (
                          uiSalidas[salida].processingState === 'locked' &&
                          uiSalidas[salida].omitReason !== ''
                        )
                      ) && (
                          <TableRow key={`omit-salida-${salida}`}>
                            <TableCell colSpan={8}>
                              <input
                                type="text"
                                placeholder="Motivo de omisión"
                                value={uiSalidas[salida].omitReason}
                                onChange={(e) =>
                                  updateSalidaOmitReason(salida, e.target.value)
                                }
                                disabled={uiSalidas[salida].processingState === 'locked'}
                                style={{
                                  width: '100%',
                                  padding: '8px',
                                  borderRadius: '6px',
                                  border: '1px solid #ccc',
                                }}
                              />
                            </TableCell>
                          </TableRow>
                        )}


                      {uiSalidas[salida].tickets.map((t) => {
                        const item = t.raw;
                        const isForgiven = t.forgiven === true;

                        return (
                          <TableRow
                            key={`tickets-salida-${salida}-ticket-${t.id}`}
                            className="print-data-row"
                            style={{
                              ...calcDiffColor(item),
                              opacity: isForgiven ? 0.6 : 1,
                            }}
                          >
                            <TableCell className={classes.columnAction} padding="none" />
                            <TableCell>
                              {devices[item.device]?.name}
                            </TableCell>
                            <TableCell>
                              {item.geofence}
                            </TableCell>
                            <TableCell>
                              {item.group}
                            </TableCell>
                            <TableCell>
                              {item.expectedTime ? formatDate(new Date(item.expectedTime), 'yyyy-MM-dd HH:mm:ss') : 'Sin registro'}
                            </TableCell>
                            <TableCell>
                              {needsRecalculation(t) ? (
                                <Button
                                  disabled={t.recalculating}
                                  onClick={() => recalculateTicket(salida, t.id)}
                                  style={{
                                    padding: '4px 8px',
                                    borderRadius: '4px',
                                    border: '1px solid #000000',
                                    cursor: t.recalculating ? 'not-allowed' : 'pointer',
                                    opacity: t.recalculating ? 0.6 : 1,
                                  }}
                                >
                                  {t.recalculating ? 'Recalculando…' : 'Recalcular'}
                                </Button>

                              ) : (
                                item.enterTime
                                  ? formatDate(new Date(item.enterTime), 'yyyy-MM-dd HH:mm:ss')
                                  : 'Sin registro'
                              )}
                            </TableCell>

                            <TableCell>
                              {item.difference}
                            </TableCell>
                            <TableCell style={{ ...(isForgiven ? { textDecoration: 'line-through' } : {}) }}>
                              {(item.progressPunishment > 0 ? item.progressPunishment : (item.globalCostPunishment > 0 ? item.globalCostPunishment : (item.difference > 0 ? item.punishment : 0)))}
                            </TableCell>
                            <TableCell>
                              {isPunishable(t) ? (
                                <input
                                  type="text"
                                  placeholder="Excusa"
                                  value={t.excuse}
                                  onChange={(e) =>
                                    updateTicketExcuse(salida, t.id, e.target.value)
                                  }
                                  disabled={isLocked}
                                  style={{
                                    width: '100%',
                                    padding: '4px',
                                    borderRadius: '4px',
                                    border: '1px solid #ccc',
                                  }}
                                />
                              ) : (
                                <span style={{ opacity: 0.5 }}>—</span>
                              )}
                            </TableCell>
                            <TableCell></TableCell>
                          </TableRow>
                        )
                      })}
                      <TableRow key={`salida-${salida}-end`} ref={el => (rowRefs.current[salida].end = el)}>
                        <TableCell colSpan={12}>
                          <List dense>
                            {uiSalidas[salida].computedNotes.map((note, index) => (
                              <ListItem key={index}>
                                <ListItemIcon>
                                  <InfoOutlined fontSize="small" />
                                </ListItemIcon>
                                <ListItemText primary={note} />
                              </ListItem>
                            ))}
                          </List>
                        </TableCell>
                      </TableRow>

                    </React.Fragment>);
                }) : (
                  <TableShimmer columns={10} startAction />
                )}
              </TableBody>
            </Table>
          )}


          <div style={{ marginTop: '24px' }}>
            <strong>Cargos adicionales:</strong>

            {extraCharges.map(charge => (
              <div
                key={charge.id}
                style={{
                  display: 'flex',
                  gap: '8px',
                  marginBottom: '8px',
                  alignItems: 'center',
                }}
              >
                <input
                  type="text"
                  placeholder="Descripción"
                  value={charge.description}
                  onChange={(e) =>
                    updateExtraCharge(charge.id, 'description', e.target.value)
                  }
                  style={{
                    flex: 2,
                    padding: '6px',
                    borderRadius: '6px',
                    border: '1px solid #ccc',
                  }}
                />

                <input
                  type="number"
                  placeholder="Monto"
                  value={charge.amount}
                  onChange={(e) =>
                    updateExtraCharge(charge.id, 'amount', e.target.value)
                  }
                  style={{
                    flex: 1,
                    padding: '6px',
                    borderRadius: '6px',
                    border: '1px solid #ccc',
                  }}
                />

                <Button
                  variant="outlined"
                  color="error"
                  onClick={() => removeExtraCharge(charge.id)}
                >
                  X
                </Button>
              </div>
            ))}

            <Button
              variant="contained"
              size="small"
              onClick={addExtraCharge}
            >
              Agregar cargo
            </Button>
          </div>


          <div
            style={{
              margin: '16px 0',
              padding: '16px',
              borderRadius: '8px',
              background: '#f5f5f5',
              display: 'flex',
              justifyContent: 'space-between',
              alignItems: 'center',
            }}
          >
            <strong>Total a cobrar:</strong>
            <span style={{ fontSize: '1.2em' }}>
              ${getGlobalTotal(uiSalidas).toFixed(2)}
            </span>
          </div>
          {omitted.length > 0 && (
            <div style={{ marginTop: '16px' }}>
              <strong>Salidas omitidas:</strong>
              <ul>
                {omitted.map(o => (
                  <li key={o.id}>
                    Salida del dia:
                    {' '}
                    {formatearFechaES(uiSalidas[o.id].meta.date)}
                    {' '}
                    {o.reason && ` — ${o.reason}`}
                  </li>
                ))}
              </ul>
            </div>
          )}

          {excused.length > 0 && (
            <div style={{ marginTop: '16px' }}>
              <strong>Excusas aplicadas:</strong>
              <ul>
                {excused.map((e, idx) => (
                  <li key={idx}>
                    Salida del dia:
                    {' '}
                    {formatearFechaES(uiSalidas[e.salidaId].meta.date)} -
                    {' '}
                    Excusa: {e.excuse} -
                    {' '}
                    Geocerca: {uiSalidas[e.salidaId].tickets.find(t => t.id === e.ticketId).raw.geofence}
                    {' '}(${e.punishment})
                  </li>
                ))}
              </ul>
            </div>
          )}
          <Button
            fullWidth
            variant="contained"
            color="primary"
            // disabled={committing || committed}
            disabled={(Object.keys(uiSalidas).length <= 0 || chargeable.length <= 0)}
            onClick={commitAndPrint}
          >
            {committing
              ? 'Guardando...'
              : committed
                ? 'Recibo generado'
                : 'Guardar y imprimir recibo'}
          </Button>

          <br />
          <br />
          {Object.keys(receiptsMap).length > 0 && (
            <div style={{ marginBottom: '20px' }}>
              <strong>Recibos generados:</strong>
              {Object.keys(receiptsMap).map(rid => (
                <div key={rid} style={{ display: 'flex', gap: '18px', marginBottom: '8px' }}>
                  <Button
                    variant="outlined"
                    onClick={() => {
                      const receiptData = buildReceiptDataFromReceiptId(Number(rid));
                      printReceipt(receiptData);
                    }}
                  >
                    Imprimir recibo minimizado#{rid}
                  </Button>
                  <Button
                    variant="outlined"
                    onClick={() => {
                      const receiptData = buildReceiptDataFromReceiptId(Number(rid));
                      printReceipt(receiptData, false);
                    }}
                  >
                    Imprimir recibo completo#{rid}
                  </Button>
                </div>

              ))}
            </div>
          )}

        </div>
      </div>
    </PageLayout >
  );
};

export default TicketReportPage;
